// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2hXX3","inner":"Form_inner__anKe4","range":"Form_range__1PhdQ","name":"Form_name___Lydg","actions":"Form_actions__30NRP"};